import request from '@/utils/request'
const root = '/purchaseContractApproval'
export const options = () => request({ url: root + '/options' })
export const purchases = keyword => request({ url: root + '/purchases', params: { keyword } })
export const defaults = id => request({ url: root + '/defaults/' + id })
export const detail = id => request({ url: root + '/detail/' + id })
export const list = params => request({ url: root + '/list', params })
export const save = data => request({ url: root + '/save', method: 'post', data })
export const submit = data => request({ url: root + '/submit', method: 'post', data })
export const withdraw = data => request({ url: root + '/withdraw', method: 'post', data })
export const completeSeal = data => request({ url: root + '/completeSeal', method: 'post', data })
